const homeSl = {
	hero: {
		title: 'ග්‍රාමීන් බසාර් වෙත සාදරයෙන් පිළිගනිමු',
		subtitle: 'ඔබට අවශ්‍ය දේ සොයන්න',
	},
	search: {
		placeholderDefault: 'නිෂ්පාදන සෙවීම...',
		typewriterPlaceholders: ['චාච්කොයිර් බසාර්', 'ජනරාල් ස්ටෝර්', 'ඇලීම් ස්ටෝර්', 'නීවර කුරාකන්'],
	},
	partners: {
		heading: 'අපගේ හවුල්කරුවන්',
		subheading: 'විශ්වාසදායක ආයතන් සමඟ සහභාගීත්වය',
	},
};

export default homeSl;


